import React from "react";

/* Simple inline chart blocks — funnel + bar, no chart lib.
   Keeps print-friendly behaviour and avoids new deps. */

const _max = (data) => Math.max(1, ...data.map((d) => d.value ?? d.count ?? 0));

const Funnel = ({ title, data }) => {
  const m = _max(data);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold text-slate-800 mb-3">{title}</h3>
      <div className="space-y-1.5">
        {data.map((r) => {
          const v = r.count ?? r.value ?? 0;
          const pct = Math.max(2, Math.round((v / m) * 100));
          return (
            <div key={r.stage} className="flex items-center gap-3">
              <div className="w-36 text-xs text-slate-600 capitalize">{String(r.stage).replace(/_/g, " ")}</div>
              <div className="flex-1 bg-slate-50 rounded-md h-7 relative overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-violet-500 to-violet-400 rounded-md"
                  style={{ width: `${pct}%` }}
                />
                <div className="absolute inset-0 flex items-center px-2 text-xs font-semibold text-slate-900 tabular-nums">{v.toLocaleString()}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const Bar = ({ title, data }) => {
  const m = _max(data);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold text-slate-800 mb-3">{title}</h3>
      <div className="space-y-1.5">
        {data.map((r) => {
          const v = r.value ?? 0;
          const pct = Math.max(2, Math.round((v / m) * 100));
          return (
            <div key={r.label} className="flex items-center gap-3">
              <div className="w-36 text-xs text-slate-600 truncate" title={r.label}>{r.label}</div>
              <div className="flex-1 bg-slate-50 rounded-md h-6 relative overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-emerald-500 to-emerald-400 rounded-md"
                  style={{ width: `${pct}%` }}
                />
                <div className="absolute inset-0 flex items-center px-2 text-xs font-semibold text-slate-900 tabular-nums">{v.toLocaleString()}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const ReportChartBlock = ({ chart }) => {
  if (!chart?.data?.length) return null;
  if (chart.type === "funnel") return <Funnel title={chart.title} data={chart.data} />;
  if (chart.type === "bar") return <Bar title={chart.title} data={chart.data} />;
  return null;
};

export default ReportChartBlock;
